/**
 * @file The lowercase hex SHA-256 of a file's bytes, hashed in the browser
 * with SubtleCrypto. It is the `pdfIntakeJobs` job id and the
 * `pricebookEditions` edition id for those bytes, so the Upload dialog can find
 * a duplicate before anything uploads, and `startPdfIntake` and
 * `startPdfIntakePricebook` can key their `intakeState.uploads` entry before
 * the upload starts. Unlike `uploadTempAttachment`'s `fileId`, it hashes the
 * bytes alone, without the extension.
 */
export async function fileSha256(content: Uint8Array<ArrayBuffer>): Promise<string> {
  return Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', content)), (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('');
}
